import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SidepanelEventsService {
  public readonly onFullWidth = new EventEmitter<void>();
}
